import { TileBase } from "./TileBase";
import { Game, eModelAsset } from "../../../Game";
import { TIMER, Gameplay, eBatchGroup } from "../../Gameplay";
import { Player } from "../Player/Player";
import { ViewCellMap } from "../View/ViewCellMap";
import { eTileType } from "../Game Map/MapCell";
import { Pool } from "../../../Utils/Collections/Pool";



export class TrampolineTile extends TileBase {
    private static MODEL_ASSET: pc.Asset;

    /**
     * Pool s volnymi overlay pro aktivovane trampoliny
     */
    private static _FREE_OVERLAYS: Pool<pc.Entity>;

    private static readonly FLAG_ACTIVE = 0x00010000;

    /**
     * Cas aktivace trampoliny
     */
    private _actTime: number;

    /**
     * Entita s prekrytim pro aktivovanou trampolinu nebo undefined
     */
    private _actOverlay: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!TrampolineTile.MODEL_ASSET) {
            // Asset s modelem trampoliny
            TrampolineTile.MODEL_ASSET = Game.app.assets.find(eModelAsset.tileTrampoline_0, pc.ASSET_MODEL);

            // Overlays
            TrampolineTile._FREE_OVERLAYS = new Pool<pc.Entity>(undefined, 2, true, (): pc.Entity => {
                let e = new pc.Entity();

                e.enabled = false;
                e.addComponent(pc.eCompomentType.model, {
                    type: pc.eModelType.asset,
                    asset: Game.app.assets.find(eModelAsset.trampOverlay_0, pc.ASSET_MODEL),
                    castShadows: false,
                    castShadowsLightmap: false,
                    receiveShadows: false,
                    batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.solid_0]
                });

                return e;
            });
        }

        super(eTileType.trampoline);
        this._entity.model.asset = TrampolineTile.MODEL_ASSET;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        if (this._actOverlay) {
            this._actOverlay.enabled = false;
            TrampolineTile._FREE_OVERLAYS.returnItem(this._actOverlay);
            this._actOverlay = undefined;
        }

        super.release();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if ((this._flags & TrampolineTile.FLAG_ACTIVE) != 0) {
            let progress = (TIMER.time - this._actTime) / 750;

            if (progress > 1)
                progress = 1;

            let pos = this._entity.getLocalPosition();

            pos.y = 0.5 * pc.ElasticOut(progress);
            this._entity.setLocalPosition(pos);

            if (progress == 1) {
                this._flags &= ~TrampolineTile.FLAG_ACTIVE;
                return false;
            }
        }

        return true;
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat kolizi s hracem
     */
    //-------------------------------------------------------------------------
    handleCollision(player: Player): boolean {
        if ((this._flags & TileBase.FLAG_HANDLE_COLLISION) != 0 && Math.abs(player.position.z - this._entity.getPosition().z) <= TileBase.SIZE * 0.3) {
            this._flags &= ~TileBase.FLAG_HANDLE_COLLISION;
            this._flags |= TrampolineTile.FLAG_ACTIVE;
            this._actTime = TIMER.time;

            // Aktivovat dlazdici
            ViewCellMap.instance.addTileToActList(this);

            let overlay = TrampolineTile._FREE_OVERLAYS.getItem();

            if (overlay.parent != this._entity)
                overlay.reparent(this._entity);

            overlay.enabled = true;
            this._actOverlay = overlay;

            // Zahajit skok hrace
            player.startJump();

            return true;
        }

        return false;
    }
}